import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});



/**
 * ===============================
 * CLIENT EVENTS SERVICE (PUBLIC)
 * ===============================
 */



/**
 * Get all events
 */
export const fetchAllEvents = async () => {

  try {

    const response = await api.get("/public/events");

    return {
      status: response.status,
      data: response.data,
    };

  } catch (err) {

    return {
      status: err.response?.status || 500,
      data: [],
      message:
        err.response?.data?.message ||
        err.message ||
        "Failed to fetch events",
    };

  }

};



/**
 * Book Event
 * POST /api/user/events/book
 */
export const bookEvent = async (bookingRequest) => {

  try {

    const response = await api.post(
      "/public/events/book",
      bookingRequest
    );

    return {
      status: response.status,
      data: response.data,
      message: "Event booked successfully",
    };

  } catch (err) {

    return {
      status: err.response?.status || 500,
      data: null,
      message:
        err.response?.data?.message ||
        err.message ||
        "Failed to book event",
    };

  }

};


/**
 * Get all bookings of a user
 * GET /api/user/events/bookings/user/{userId}
 */
export const fetchUserBookings = async (userId) => {

  try {

    const response = await api.get(
      `/public/events/bookings/user/${userId}`
    );

    return {
      status: response.status,
      data: response.data,
    };

  } catch (err) {

    return {
      status: err.response?.status || 500,
      data: [],
      message:
        err.response?.data?.message ||
        err.message ||
        "Failed to fetch bookings",
    };

  }

};


/**
 * Get booking details
 * GET /api/user/events/bookings/{bookingId}
 */
export const fetchBookingById = async (bookingId) => {

  try {

    const response = await api.get(
      `/public/events/bookings/${bookingId}`
    );

    return {
      status: response.status,
      data: response.data,
    };

  } catch (err) {

    return {
      status: err.response?.status || 500,
      data: null,
      message:
        err.response?.data?.message ||
        err.message ||
        "Failed to fetch booking details",
    };

  }

};


/**
 * Join Zoom Meeting
 */
export const joinZoomMeeting = (zoomLink) => {

  try {

    if (!zoomLink) {

      return {
        status: 400,
        message: "Zoom link not available",
      };

    }

    window.open(
      zoomLink,
      "_blank",
      "noopener,noreferrer"
    );

    return {
      status: 200,
      message: "Zoom opened successfully",
    };

  } catch (error) {

    return {
      status: 500,
      message: "Failed to open Zoom link",
    };

  }

};


/**
 * Get all bookings by email (Guest or Logged-in user)
 * GET /api/public/events/bookings/email/{email}
 */
export const fetchBookingsByEmail = async (email) => {

  try {

    if (!email) {

      return {
        status: 400,
        data: [],
        message: "Email is required",
      };

    }

    const response = await api.get(
      `/public/events/bookings/email/${encodeURIComponent(email)}`
    );

    return {
      status: response.status,
      data: response.data,
      message: "Bookings fetched successfully",
    };

  } catch (err) {

    return {
      status: err.response?.status || 500,
      data: [],
      message:
        err.response?.data?.message ||
        err.message ||
        "Failed to fetch bookings",
    };

  }

};